import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "rounded-xl border-gray-100 shadow-xl p-6" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "w-4/5" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "font-bold text-green-700" }, "Stock antigüedad maderas", -1)
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-gray-600 mt-1"
}
const _hoisted_6 = { class: "flex flex-1 justify-end" }
const _hoisted_7 = {
  key: 0,
  class: "text-sm text-center my-4"
}
const _hoisted_8 = {
  key: 1,
  class: "text-sm text-center my-4"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "p-2" }, null, -1)
const _hoisted_11 = { class: "flex justify-between" }
const _hoisted_12 = { class: "font-bold text-green-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UITextSelect = _resolveComponent("UITextSelect")
  const _component_Bar = _resolveComponent("Bar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        ($setup.selectedCanchaName)
          ? (_openBlock(), _createBlock("p", _hoisted_5, _toDisplayString($setup.selectedCanchaName), 1))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_UITextSelect, {
          items: $setup.canchas,
          onSelected: _cache[1] || (_cache[1] = (canchaId) => $setup.requestStats(canchaId))
        }, null, 8, ["items"])
      ])
    ]),
    ($setup.isLoading)
      ? (_openBlock(), _createBlock("p", _hoisted_7, "...cargando stats"))
      : ($setup.selectedCancha && !$setup.hasStatsData)
        ? (_openBlock(), _createBlock("p", _hoisted_8, "Sin datos"))
        : ($setup.selectedCancha && $setup.hasStatsData)
          ? (_openBlock(), _createBlock("div", _hoisted_9, [
              _createVNode(_component_Bar, {
                "chart-data": $setup.chartData,
                height: 250,
                "chart-options": { locale: 'es-ES', plugins: { legend: { display: false } } }
              }, null, 8, ["chart-data"]),
              _hoisted_10,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.items, (item) => {
                return (_openBlock(), _createBlock("div", {
                  key: item.text + item.value
                }, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("p", _hoisted_12, _toDisplayString(item.text), 1),
                    _createVNode("p", null, _toDisplayString(item.value.toLocaleString('es-CL')), 1)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
  ]))
}